import type { TextareaHTMLAttributes } from "react";
import clsx from "clsx";
import { fieldControlClassName } from "./form-control-styles";

export const Textarea = ({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) => (
  <textarea
    className={clsx(
      fieldControlClassName,
      "min-h-28 px-3 py-2",
      className,
    )}
    {...props}
  />
);

export default Textarea;
